import { RequiredArticle } from '../../Article';
import { ArticleColorPersistenceMapper } from './ArticleColorPersistenceMapper';

export class RequiredArticlePersistenceMapper {
  public static toDto = (
    requiredArticle: RequiredArticle
  ): SimpleProjectServiceAPI.RequiredArticleDto => ({
    id: requiredArticle.id,
    number: requiredArticle.number,
    colors: requiredArticle.colors.map(ArticleColorPersistenceMapper.toDto),
    amount: requiredArticle.amount
  });

  public static toDomain = (
    dto: SimpleProjectServiceAPI.RequiredArticleDto
  ): RequiredArticle => ({
    id: dto.id,
    number: dto.number,
    colors: dto.colors.map(ArticleColorPersistenceMapper.toDomain),
    amount: dto.amount,
    definition: undefined
  });
}
